export default __webpack_public_path__ + "static/media/step3.9f32ae66.svg";